export default __webpack_public_path__ + "static/media/oracleDB.004f88c0.webp";